import React, { useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { updatePageHistory } from "../../fast-quote/page-history";

import {
  Box,
  MaskedInput,
  Text,
  TextArea,
  Select,
  Spinner,
  CheckBox,
  Notification,
} from "grommet";

import "./ContactForm.css";
import { EstimateService } from "../../services/estimates.service";
import ReCAPTCHA from "react-google-recaptcha";
import { Steps } from "../../fast-quote/steps";

const wind: any = window;

declare var rudderanalytics: any;
declare var filterData: any;
// Declare gTM dataLayer array.
declare global {
  interface Window {
    dataLayer: any[];
  }
}

let channelPartnerIdsMap: any = {};
if (process.env.REACT_APP_ENV === "development") {
  console.log("development");
  channelPartnerIdsMap = { "Graze Master": "0017500000GQhANAA1" };
} else {
  channelPartnerIdsMap = { "Graze Master": "0018W00001pNOqtQAG" };
}

const stateMap: any = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const getTitle = (str: string) => {
  const spaceIndex = str.indexOf("|");
  return spaceIndex === -1 ? str : str.substring(0, spaceIndex);
};

const ContactForm = ({ allQuoteParams, backButton }: any) => {
  // Create recaptchaRef reference for typescript
  const [recaptcha, setRecaptcha] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [howDidYouHear, setHowDidYouHear] = useState("");
  const [contactPreference, setContactPreference] = useState("");
  const [howDidYouHearAdditionalText, setHowDidYouHearAdditionalText] =
    useState("");
  const [message, setMessage] = useState("");

  const [receiveInformationEmails, setReceiveInformationEmails] =
    useState(false);
  const [termsAgreement, setTermsAgreement] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);

  const [firstNameFocused, setFirstNameFocused] = useState(false);
  const [lastNameFocused, setLastNameFocused] = useState(false);
  const [phoneFocused, setPhoneFocused] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const rawPayload = allQuoteParams.params;

  const [visible, setErrorVisible] = React.useState(false);
  const [submited, setSubmited] = React.useState(false);

  const [city, setCity] = useState("");

  const channelPartner: string | null = searchParams.get("channelPartner");

  let channelPartnerId: string | null = null;
  let leadType = "Grower";
  if (channelPartner) {
    channelPartnerId = channelPartnerIdsMap[channelPartner];
    leadType = "Channel";
  }

  const goBack = () => {
    setSubmissionComplete(false);
    setSubmitting(false);
    backButton();
  };
  const setPhoneRaw = (event: any) => {
    const key = event.nativeEvent.inputType;
    let value = event.target.value;
    if (key === "deleteContentBackward") {
      setPhone(value);
      return;
    }
    if (value.length === 3) {
      value = value + "-";
    } else if (value.length === 7) {
      value = value + "-";
    }

    setPhone(value);
  };

  const isPhoneValid = () => {
    var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return re.test(phone);
  };

  const isEmailValid = () => {
    // return true;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidFormat = String(email).toLowerCase().match(emailRegex);
    
    // Check if email has @icloud.com domain
    const hasIcloudDomain = String(email).toLowerCase().includes('@icloud.com');
    
    return isValidFormat && !hasIcloudDomain;
  };

  const activateSubmit =
    firstName.trim().length > 0 &&
    lastName.trim().length > 0 &&
    isPhoneValid() &&
    isEmailValid() &&
    termsAgreement;

  const hidePayout = allQuoteParams.hidePayout;

  const values = {
    formName: "FastQuoteForm",
    firstName: firstName,
    lastName: lastName,
    email: email,
    phone: phone,
    HowDidYouHear: howDidYouHear,
    HowDidYouHearAdditionalText: howDidYouHearAdditionalText,
    contactPreference: contactPreference,
    message: message,

    hidePayout: hidePayout,

    countyParam: allQuoteParams.countyParam,
    stateParam: stateMap[allQuoteParams.stateParam],

    rowCropAreaParam: allQuoteParams.rowCropAreaParam,
    rowPastureAreaParam: allQuoteParams.rowPastureAreaParam,

    totalAreaParam: allQuoteParams.totalAreaParam,
    potentialPayoutParam: allQuoteParams.potentialPayoutParam,
    quoteParams: allQuoteParams.params,
  };

  const getCookie = (cname: any) => {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const handleSubmit = async () => {
    const win: any = window;
    const AnonymousId = win.rudderanalytics?.getAnonymousId() || 0;
    setSubmited(true);
    const activateSubmit =
      firstName.trim().length > 0 &&
      lastName.trim().length > 0 &&
      city.trim().length > 0 &&
      isPhoneValid() &&
      isEmailValid() &&
      termsAgreement;

    if (wind.RUDDERSTACK_ENVIRONMENT === "production" && recaptcha === "") {
      return false;
    }

    if (!activateSubmit) {
      return false;
    }

    let interestedIn = "";
    if (
      values.rowCropAreaParam &&
      values.rowCropAreaParam > 0 &&
      values.rowPastureAreaParam &&
      values.rowPastureAreaParam > 0
    ) {
      interestedIn = "Row Crops & Pasture/Rangelands";
    } else if (values.rowCropAreaParam && values.rowCropAreaParam > 0) {
      interestedIn = "Row Crops";
    } else if (values.rowPastureAreaParam && values.rowPastureAreaParam > 0) {
      interestedIn = "Pasture/Rangelands";
    }

    setSubmitting(true);
    if (
      typeof rudderanalytics == "undefined" ||
      rudderanalytics == null ||
      rudderanalytics === undefined ||
      rudderanalytics === ""
    ) {
      console.log("rudderanalytics is NOT loaded");
    } else {

      let acres =
        allQuoteParams.rowCropAreaParam + allQuoteParams.rowPastureAreaParam;

      // Set localStorage for API usage
      localStorage.setItem("apiEmail", email);

      const rudderstackPayloadIndentify = filterData({
        Acres: acres,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        SourceDetails: values?.formName,
        LeadSource: "WebsiteCarbonCalculator",
        HowDidYouHear: howDidYouHear,
        HowDidYouHearAdditionalText: howDidYouHearAdditionalText,
        contactPreference: contactPreference,
        country: "United States",
        state: values?.stateParam,
        city: city,
        InterestedIn: interestedIn,
        description: message,
        receiveInformationEmails: receiveInformationEmails,
        ContactFormTermsAgreement: termsAgreement,

        channelPartnerName: channelPartner,
        channelPartnerId: channelPartnerId,
        LeadType: leadType,

        utm_source: getCookie("utm_source"),
        utm_medium: getCookie("utm_medium"),
        utm_campaign: getCookie("utm_campaign"),
        utm_term: getCookie("utm_term"),
        utm_content: getCookie("utm_content"),
        AnonymousId: AnonymousId,
      });

      const rudderstackPayloadTrack = filterData({
        hidePayout: values?.hidePayout,
        Acres: acres,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        SourceDetails: values?.formName,
        LeadSource: "WebsiteCarbonCalculator",
        HowDidYouHear: howDidYouHear,
        HowDidYouHearAdditionalText: howDidYouHearAdditionalText,
        contactPreference: contactPreference,
        country: "United States",
        state: values?.stateParam,
        city: city,
        InterestedIn: interestedIn,
        description: message,
        receiveInformationEmails: receiveInformationEmails,
        ContactFormTermsAgreement: termsAgreement,

        channelPartnerName: channelPartner,
        channelPartnerId: channelPartnerId,
        LeadType: leadType,

        utm_source: getCookie("utm_source"),
        utm_medium: getCookie("utm_medium"),
        utm_campaign: getCookie("utm_campaign"),
        utm_term: getCookie("utm_term"),
        utm_content: getCookie("utm_content"),
        AnonymousId: AnonymousId,
      });

      // CoverCropsAcres: allQuoteParams.rowCropAreaParam,
      // ReducedTillAcres: allQuoteParams.rowCropAreaParam,
      // NOptimizationAcres: allQuoteParams.rowCropAreaParam,

      // RangeAndPastureAcres: values?.rowPastureAreaParam,

      // CoverCropsAdopted: values?.rowCropCoverCroppingParam,
      // NitrogenManagement: values?.rowCropNitrogenReductionParam,
      // ReducedTillAdopted: values?.rowCropReducedTillageParam,
      // RangeAndPasture: values?.pastureFertilizationParam,
      // RangeAndPastureAdopted: values?.pastureImp˜rovedGrazingParam,

      // send event to rudderstack
      let res = rudderanalytics.identify(email, rudderstackPayloadIndentify, {
        integrations: {
          Salesforce: false, // do not create anything in SF, use the base be to create it
          Amplitude: {
            session_id: getCookie("session_id"),
          },
        },
      });

      // send event to rudderstack
      res = rudderanalytics.track(
        "Fast Quote Form Submit Agoro " + values?.formName,
        { ...rudderstackPayloadTrack, rawPayload },
        {
          integrations: {
            RS: {
              options: {
                jsonPaths: ["rawPayload"],
              },
            },
          },
        }
      );

      res = rudderanalytics.page(
        getTitle("Calculator Second Page Button Click"),
        {
          integrations: {
            Amplitude: {
              session_id: getCookie("session_id"),
            },
          },
        }
      );

      updatePageHistory("Calculator Second Page Button Click");
    }

    EstimateService.sendInformation(
      values,
      firstName,
      lastName,
      email,
      phone,
      city,
      howDidYouHear,
      howDidYouHearAdditionalText,
      message,
      receiveInformationEmails,
      termsAgreement,
      interestedIn,
      channelPartner,
      channelPartnerId,
      leadType,
      getCookie,
      setSubmissionComplete,
      setErrorVisible,
      setSubmitting,
      AnonymousId,
      contactPreference
    );
  };

  const payoutBox = (
    <Box className="ContactForm__PayoutBox">
      <Text size={"1rem"} weight={800} textAlign={"center"}>
        Potential payout over 10 years
      </Text>
      <Text
        size={"2rem"}
        margin={"0.25rem 0 0 0"}
        textAlign={"center"}
        color="#282828"
        weight={800}
        style={{ lineHeight: "2rem" }}
      >
        {allQuoteParams?.potentialPayoutParam &&
          (
            Math.round(allQuoteParams.potentialPayoutParam * 100) / 100
          ).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
      </Text>
    </Box>
  );

  let acres =
    allQuoteParams.rowCropAreaParam + allQuoteParams.rowPastureAreaParam;
  let isUnqualified = false;
  if (allQuoteParams.params.scenarios) {
    isUnqualified = allQuoteParams.params.scenarios[0].details.isUnqualified;
  }
  const baseUrl =
    process.env.REACT_APP_ENV === "development"
      ? "https://website.stage.us.agorocarbon.com/"
      : "https://agorocarbonalliance.com/";

  let redirectURL = `${baseUrl}thank-you-calculator`;
  if (parseInt(acres) < 500) {
    redirectURL = `${baseUrl}thankyou-calculator`;
  }
  if(isUnqualified) {
    redirectURL = `${baseUrl}thank-you-nqs/`;
  }
  let payoutAmmount =
    allQuoteParams?.potentialPayoutParam &&
    (
      Math.round(allQuoteParams.potentialPayoutParam * 100) / 100
    ).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

  if (submissionComplete) {
    if (typeof window.dataLayer !== "undefined") {
      window.dataLayer.push({ event: "Calculator Final Submit" });
    }
    setTimeout(function () {
      //Submit form
      document.getElementById("redirectFormSubmit")?.click();
    }, 1000);
  }

  return (
    <div className="ContactForm">
      {/* <Box justify={'center'}>
        <Box
          direction={'row'}
          alignContent={'center'}
          width={'fit-content'}
          style={{ minHeight: 'unset' }}
          onClick={() => goBack()}
        >

          <FormPreviousLink color="black"
            fontSize={"2.5rem"}
            style={{
              verticalAlign: 'bottom',
              cursor: 'pointer',
              marginTop: '1.5rem',
              marginLeft: "2rem"
            }}
          />
          <Text
            margin={'1.8rem 0 0.75rem 0.2rem'}
            size={'1rem'}
            style={{ fontWeight: 400 }}
            onClick={() => goBack()}
          >
            Back
          </Text>
        </Box>
      </Box> */}

      {!hidePayout && payoutBox}

      {submissionComplete && (
        <Box justify={"center"}>
          <form method="post" action={redirectURL} id="redirectForm">
            <input type="hidden" name="calc_acres" value={acres} />
            <input type="hidden" name="calc_amount" value={payoutAmmount} />
            <input type="hidden" name="calc_email" value={email} />
            <input type="hidden" name="calc_name" value={`${firstName} ${lastName}`} />
            <input
              type="hidden"
              name="calc_name"
              value={`${firstName} ${lastName}`}
            />
            <button
              id="redirectFormSubmit"
              type="submit"
              style={{ display: "none" }}
            ></button>
          </form>

          {/* <Text size={'2rem'} style={{ margin: "2rem", marginBottom: "0rem" }} weight={400} >Thank You</Text>

        <Text size={'1rem'} style={{ margin: "0.5rem 2rem 1rem 2rem", marginTop: "0rem" }} weight={400}>
          We received your request to kick-start your carbon journey and are looking forward to connecting with you.
        </Text>
        
        {hidePayout && payoutBox}

        <div style={{ margin: "1rem 2rem 2rem 2rem", display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{display: "flex", width: "45%"}}>
            <Box
              border={{ color: '#282828', size: '2px', style: 'solid' }}
              className="ContactForm__resources"
              style={{ minHeight: 'unset', margin: "auto" }}
              width={'fit-content'}
              pad={'0.5rem 1rem'}
              direction='row'
              align='center'
              justify={'center'}
              onClick={e => document.location = "/how-it-works/"}
            >
              <Text weight={800}>
                How It Works
              </Text>
            </Box>
          </div>
          <div style={{display: "flex", width: "45%"}}>
            <Box
              border={{ color: '#282828', size: '2px', style: 'solid' }}
              className="ContactForm__resources"
              style={{ minHeight: 'unset', margin: "auto" }}
              width={'fit-content'}
              pad={'0.5rem 1rem'}
              direction='row'
              align='center'
              justify={'center'}
              onClick={e => document.location = "/contact/farmers-ranchers/"}
            >
              <Text weight={800}>
                Get Started
              </Text>
            </Box>
          </div>
        </div>
         */}
        </Box>
      )}

      {!submissionComplete && (
        <Box justify={"center"}>
          <div className="center-second">
            <div className="ContactForm__CenterHeader">
              <h2 className="Contact_Header">
                Final step to see your carbon earning potential
              </h2>
            </div>
            <Text className="Contact_Description">
              A few more get-to-know-you questions so we can best advise you -
              then let's get to your carbon earning potential! Simply fill out
              the form below and one of our local agronomists will be in touch
              to start the conversation.
            </Text>

            <Steps step={2} />

            <form id="contactForm">
              <Box
                height={"fit-content"}
                overflow={{ vertical: "auto" }}
                className={"hideScrollBox"}
              >
                <div
                  className="ContactForm__BackButton"
                  style={{ marginBottom: "1rem", marginLeft: "2rem" }}
                >
                  <Box
                    direction={"row"}
                    alignContent={"center"}
                    width={"fit-content"}
                    style={{ minHeight: "unset", cursor: "pointer" }}
                    onClick={() => goBack()}
                  >
                    <Text
                      size={"1rem"}
                      style={{ fontWeight: 400, textDecoration: "underline" }}
                    >
                      ← Back to Practices
                    </Text>
                  </Box>
                </div>

                {allQuoteParams.params.scenarios && allQuoteParams.params.scenarios[0].details.isUnqualified && (
                  <div
                    className="ContactForm__NQInfoBox"
                    style={{ marginBottom: "1rem", marginLeft: "2rem" }}
                  >
                    <Box
                      direction={"row"}
                      alignContent={"center"}
                      width={"fit-content"}
                      style={{ minHeight: "unset", cursor: "pointer" }}
                    >
                      <Text>
                        Thanks for your interest! Enrollment isn’t open in your
                        area right now, but share your details below so you’ll
                        be the first to know when it is!
                      </Text>
                    </Box>
                  </div>
                )}

                <div className="ContactForm__Container">
                  <div className="ContactForm__Column">
                    <Box direction={"row"} margin={"0 0 0.5rem 0"}>
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        First Name *
                      </Text>
                    </Box>
                    <Box
                      border={{ color: "#282828", size: "2px", style: "solid" }}
                      className={
                        submited && firstName.length === 0
                          ? "ContactForm__BoxInvalid"
                          : ""
                      }
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{ minHeight: "unset" }}
                    >
                      <MaskedInput
                        style={{
                          fontWeight: 800,
                          fontFamily: "Nunito Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                        }}
                        plain
                        size="1.25rem"
                        focusIndicator={false}
                        placeholder="First Name"
                        onChange={(e) => setFirstName(e.target.value)}
                        onBlur={() => setFirstNameFocused(true)}
                        value={firstName}
                      />
                    </Box>
                    {submited && firstName.length === 0 ? (
                      <div className="ContactForm_ErrorText">
                        Please provide a first name
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="ContactForm__Column">
                    <Box direction={"row"} margin={"0 0 0.5rem 0"}>
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        Last Name *
                      </Text>
                    </Box>
                    <Box
                      border={{ color: "#282828", size: "2px", style: "solid" }}
                      className={
                        submited && lastName.length === 0
                          ? "ContactForm__BoxInvalid"
                          : ""
                      }
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{ minHeight: "unset" }}
                    >
                      <MaskedInput
                        style={{
                          fontWeight: 800,
                          fontFamily: "Nunito Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                        }}
                        plain
                        size="1.25rem"
                        focusIndicator={false}
                        placeholder="Last Name"
                        onChange={(e) => setLastName(e.target.value)}
                        onBlur={() => setLastNameFocused(true)}
                        value={lastName}
                      />
                    </Box>
                    {submited && lastName.length === 0 ? (
                      <div className="ContactForm_ErrorText">
                        Please provide a last name
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {visible && (
                  <Notification
                    toast
                    status={"critical"}
                    title="Error"
                    message="Sorry, but we could not submit your request. Try again later."
                    onClose={() => setErrorVisible(false)}
                  />
                )}

                <div className="ContactForm__Container">
                  <div className="ContactForm__Column">
                    <Box
                      direction={"row"}
                      margin={"0 0 0.5rem 0"}
                      style={{ marginTop: "1rem" }}
                    >
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        Phone *
                      </Text>
                    </Box>
                    <Box
                      border={{ color: "#282828", size: "2px", style: "solid" }}
                      className={
                        submited && !isPhoneValid()
                          ? "ContactForm__BoxInvalid"
                          : ""
                      }
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{ minHeight: "unset" }}
                    >
                      <MaskedInput
                        mask={[
                          {
                            regexp: /^\d{1,3}(-){0,1}\d{0,3}(-){0,1}\d{0,4}$/,
                          },
                        ]}
                        style={{
                          fontWeight: 800,
                          fontFamily: "Nunito Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                        }}
                        plain
                        size="1.25rem"
                        focusIndicator={false}
                        placeholder="###-###-####"
                        value={phone}
                        onChange={(e) => setPhoneRaw(e)}
                        onBlur={() => setPhoneFocused(true)}
                      />
                    </Box>
                    {submited && !isPhoneValid() ? (
                      <div className="ContactForm_ErrorText">
                        Please provide a properly formatterd phone number
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="ContactForm__Column">
                    <Box
                      direction={"row"}
                      margin={"0 0 0.5rem 0"}
                      style={{ marginTop: "1rem" }}
                    >
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        Email *
                      </Text>
                    </Box>
                    <Box
                      border={{ color: "#282828", size: "2px", style: "solid" }}
                      className={
                        (submited || (emailFocused && email.toLowerCase().includes('@icloud.com'))) && !isEmailValid() && email.length > 0
                          ? "ContactForm__BoxInvalid"
                          : ""
                      }
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{ minHeight: "unset" }}
                    >
                      <MaskedInput
                        style={{
                          fontWeight: 800,
                          fontFamily: "Nunito Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                        }}
                        plain
                        size="1.25rem"
                        focusIndicator={false}
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        onInput={(e) => {
                          // Only trigger real-time validation for iCloud domain
                          const inputEmail = (e.target as HTMLInputElement).value;
                          if (inputEmail.toLowerCase().includes('@icloud.com')) {
                            setEmailFocused(true);
                          }
                        }}
                        onBlur={() => setEmailFocused(true)}
                        value={email}
                      />
                    </Box>
                    {(submited || (emailFocused && email.toLowerCase().includes('@icloud.com'))) && !isEmailValid() && email.length > 0 ? (
                      <div className="ContactForm_ErrorText">
                        {String(email).toLowerCase().includes('@icloud.com') 
                          ? "Please use a different email address. iCloud emails are not supported."
                          : "Please provide a properly formatted email address"
                        }
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="ContactForm__Container">
                  <div className="ContactForm__Column">
                    <Box
                      direction={"row"}
                      margin={"0 0 0.5rem 0"}
                      style={{ marginTop: "1rem" }}
                    >
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        How did you hear about us? *
                      </Text>
                    </Box>
                    <Box
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{
                        minHeight: "unset",
                      }}
                    >
                      <div
                        className={
                          submited && howDidYouHear === ""
                            ? "ContactForm__Select invalid"
                            : "ContactForm__Select"
                        }
                      >
                        <Select
                          options={[
                            "Event",
                            "Social Media",
                            "News Publication",
                            "Radio",
                            "Friend or Colleague",
                            "Referral",
                            "Other",
                            "No Response",
                          ]}
                          value={howDidYouHear}
                          onChange={(e) => setHowDidYouHear(e.target.value)}
                          style={{
                            fontWeight: 800,
                            fontFamily: "Nunito Sans",
                            fontSize: "16px",
                            fontStyle: "normal",
                          }}
                        />
                      </div>
                    </Box>
                    {submited && howDidYouHear === "" ? (
                      <div className="ContactForm_ErrorText">
                        Please select an option
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {howDidYouHear && howDidYouHear === "Other" && (
                    <div className="ContactForm__Column">
                      <Box
                        direction={"row"}
                        margin={"0 0 0.5rem 0"}
                        style={{ marginTop: "1rem" }}
                      >
                        <Text
                          style={{
                            fontWeight: 800,
                            fontSize: "16px",
                            fontFamily: "Nunito Sans",
                            fontStyle: "normal",
                            lineHeight: "22px",
                          }}
                          size={"0.8rem"}
                          margin={"0 0.25rem"}
                        >
                          Please specify source?
                        </Text>
                      </Box>
                      <Box
                        border={{
                          color: "#282828",
                          size: "2px",
                          style: "solid",
                        }}
                        width={"100%"}
                        height={"3rem"}
                        direction="row"
                        align="center"
                        style={{ minHeight: "unset" }}
                      >
                        <MaskedInput
                          style={{
                            fontWeight: 400,
                          }}
                          plain
                          size="1.25rem"
                          focusIndicator={false}
                          placeholder="How did you hear about us?"
                          onChange={(e) =>
                            setHowDidYouHearAdditionalText(e.target.value)
                          }
                          value={howDidYouHearAdditionalText}
                        />
                      </Box>
                    </div>
                  )}

                  <div className="ContactForm__Column">
                    <Box
                      direction={"row"}
                      margin={"0 0 0.5rem 0"}
                      style={{ marginTop: "1rem" }}
                    >
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        City *
                      </Text>
                    </Box>
                    <Box
                      border={{ color: "#282828", size: "2px", style: "solid" }}
                      className={
                        submited && city.length === 0
                          ? "ContactForm__BoxInvalid"
                          : ""
                      }
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{ minHeight: "unset" }}
                    >
                      <MaskedInput
                        style={{
                          fontWeight: 800,
                          fontFamily: "Nunito Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                        }}
                        plain
                        size="1.25rem"
                        focusIndicator={false}
                        placeholder="City"
                        onChange={(e) => setCity(e.target.value)}
                        value={city}
                      />
                    </Box>
                    {submited && city.length === 0 ? (
                      <div className="ContactForm_ErrorText">
                        Please provide your city
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="ContactForm__Container">
                  <div className="ContactForm__Column">
                    <Box
                      direction={"row"}
                      margin={"0 0 0.5rem 0"}
                      style={{ marginTop: "1rem" }}
                    >
                      <Text
                        style={{
                          fontWeight: 800,
                          fontSize: "16px",
                          fontFamily: "Nunito Sans",
                          fontStyle: "normal",
                          lineHeight: "22px",
                        }}
                        size={"0.8rem"}
                        margin={"0 0.25rem"}
                      >
                        CONTACT PREFERENCE *
                      </Text>
                    </Box>
                    <Box
                      width={"100%"}
                      height={"3rem"}
                      direction="row"
                      align="center"
                      style={{
                        minHeight: "unset",
                      }}
                    >
                      <div
                        className={
                          submited && contactPreference === ""
                            ? "ContactForm__Select invalid"
                            : "ContactForm__Select"
                        }
                      >
                        <Select
                          options={["Email me", "Text/SMS me", "Call me"]}
                          value={contactPreference}
                          onChange={(e) => setContactPreference(e.target.value)}
                          style={{
                            fontWeight: 800,
                            fontFamily: "Nunito Sans",
                            fontSize: "16px",
                            fontStyle: "normal",
                          }}
                        />
                      </div>
                    </Box>
                    {submited && contactPreference === "" ? (
                      <div className="ContactForm_ErrorText">
                        Please select an option
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="ContactForm__Column">&nbsp;</div>
                </div>

                <div
                  className="ContactForm__Row"
                  style={{ paddingRight: "1rem" }}
                >
                  <Box
                    direction={"row"}
                    margin={"0 0 0.5rem 0"}
                    style={{ marginTop: "1rem" }}
                  >
                    <Text
                      style={{
                        fontWeight: 800,
                        fontSize: "16px",
                        fontFamily: "Nunito Sans",
                        fontStyle: "normal",
                        lineHeight: "22px",
                      }}
                      size={"0.8rem"}
                      margin={"0 0.25rem"}
                    >
                      Message
                    </Text>
                  </Box>
                  <Box
                    border={{ color: "#282828", size: "2px", style: "solid" }}
                    width={"100%"}
                    direction="row"
                    align="center"
                    style={{ minHeight: "unset" }}
                  >
                    <TextArea
                      style={{
                        fontWeight: 800,
                        fontFamily: "Nunito Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                      }}
                      plain
                      size="1.25rem"
                      rows={3}
                      focusIndicator={false}
                      placeholder="Message"
                      onChange={(e) => setMessage(e.target.value)}
                      value={message}
                    />
                  </Box>

                  <Box
                    margin={"1rem 0 1rem 0"}
                    style={{
                      fontFamily: "Sabon LT Std",
                      fontSize: "18px",
                      lineHeight: "24px",
                    }}
                  >
                    <CheckBox
                      label="Yes, I would like to receive information from Agoro Carbon Alliance about carbon opportunities for my operation."
                      onChange={(event) =>
                        setReceiveInformationEmails(event.target.checked)
                      }
                    />
                    <div style={{ marginTop: "10px" }}></div>
                    <div
                      className={
                        submited && !termsAgreement
                          ? "ContactForm__CheckBoxError"
                          : ""
                      }
                    >
                      <CheckBox
                        label={
                          <div>
                            I agree to the{" "}
                            <a href="/terms-and-conditions" target="_blank">
                              Terms of Service.
                            </a>
                          </div>
                        }
                        onChange={(event) =>
                          setTermsAgreement(event.target.checked)
                        }
                      />
                    </div>
                    {submited && !termsAgreement ? (
                      <div className="ContactForm_ErrorText">
                        You need to agree with the Terms of service to be able
                        to send and calculate
                      </div>
                    ) : (
                      ""
                    )}
                    <br />

                    {wind.RUDDERSTACK_ENVIRONMENT === "production" ? (
                      <ReCAPTCHA
                        sitekey="6Lfeep4qAAAAAJoZpTks-c0vDW_rZsBkL5k-blP8"
                        onChange={(value) => setRecaptcha(value || "")}
                      />
                    ) : (
                      ""
                    )}
                    {wind.RUDDERSTACK_ENVIRONMENT === "production" &&
                    submited &&
                    recaptcha === "" ? (
                      <div className="ContactForm_ErrorText">
                        Please verify that you are not a robot
                      </div>
                    ) : (
                      ""
                    )}
                  </Box>

                  <Box
                    border={{ color: "#282828", size: "2px", style: "solid" }}
                    onClick={() => {
                      try {
                        handleSubmit();
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                    className={`ContactForm__submit ${
                      submitting ? "submitting" : ""
                    }`}
                  >
                    <Text>
                      {submitting ? (
                        <>
                          <Spinner color="white" /> Calculating...
                        </>
                      ) : (
                        "Send and calculate"
                      )}
                    </Text>
                  </Box>
                </div>
              </Box>
            </form>
          </div>
        </Box>
      )}
    </div>
  );
};

export default ContactForm;
